import { FacebookV2Icon } from '@/components/svg/facebook-v2-icon/facebook-v2-icon'
import { GoogleV2Icon } from '@/components/svg/google-v2-icon/google-v2-icon'
import { Button } from '@/components/v2/atoms/button/button'
import { API_URL, getApiV1BaseUrl } from '@/constants'
import cx from 'classnames'
import s from './social-auth-button.module.scss'

type Props = {
  type: 'facebook' | 'google'
  label?: string
  className?: string
  redirectUrl?: string
  errorMessage?: string
}

function renderIcon(type: Props['type']) {
  switch (type) {
    case 'facebook':
      return <FacebookV2Icon />
    case 'google':
      return <GoogleV2Icon />
    default:
      throw new Error('Incorrect social auth type provided!')
  }
}

function getAuthUrl(type: Props['type'], redirectUrl: string) {
  switch (type) {
    case 'facebook':
      const facebookUrl = new URL(`${getApiV1BaseUrl()}${API_URL.AUTH.FACEBOOK}`)
      facebookUrl.searchParams.append('redirectUrl', redirectUrl)
      return facebookUrl
    case 'google':
      const googleUrl = new URL(`${getApiV1BaseUrl()}${API_URL.AUTH.GOOGLE}`)
      googleUrl.searchParams.append('redirectUrl', redirectUrl)
      return googleUrl
    default:
      throw new Error('Incorrect social auth type provided!')
  }
}

export const SocialAuthButton = (props: Props) => {
  const { type, label, redirectUrl = '/', errorMessage } = props
  const url = getAuthUrl(type, redirectUrl)

  return (
    <>
      <Button className={cx(s.button, props.className)} href={url.toString()}>
        {renderIcon(type)}
        <div className={cx(s.buttonText)}>
          {label || `Continue with ${type}`}
        </div>
      </Button>
      {errorMessage && <div className={cx(s.errorMessage)}>{errorMessage}</div>}
    </>
  )
}
